import parseQueryParams from './query-params';


// returns where the external page is opened, e.g. '_top'. This works like the `target` parameter
// for <a> tags.

export default function externalPageTarget() {
    const { hash } = window.location;
    const hashQueryParamsString = (hash && (hash.match(/\?.*$/) || [])[0]) || '';
    const queryParamsString = hash ? hashQueryParamsString : window.location.search;
    const queryParams = parseQueryParams(queryParamsString);
    return queryParams.openTarget || '_top';
}



// WEBPACK FOOTER //
// ./src/lib/external-page-target.jsx